document.addEventListener('DOMContentLoaded', () => {

  // Power Deals Slider + Mobile Autoplay
  document.querySelectorAll('.power-deals-products').forEach(wrapper => {
    const track = wrapper.querySelector('.power-deals-track');
    const prev = wrapper.querySelector('.pd-arrow-left');
    const next = wrapper.querySelector('.pd-arrow-right');

    if (!track || !prev || !next) return;

    const getScrollAmount = () => {
      return track.querySelector('.power-deals-card')?.offsetWidth + 16 || 320;
    };

    // Manual arrows
    prev.addEventListener('click', () => {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', () => {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    // Auto play only on mobile
    if (window.innerWidth <= 768) {
      let autoSlide = setInterval(() => {
        const scrollAmount = getScrollAmount();

        // If reached end, go back to start
        if (
          track.scrollLeft + track.clientWidth >=
          track.scrollWidth - 10
        ) {
          track.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          track.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      }, 3000); // every 3 seconds

      // Pause autoplay when user touches slider
      track.addEventListener('touchstart', () => {
        clearInterval(autoSlide);
      });
    }
  });


  // Mobile Sticky Cart Count
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const badge = document.getElementById('_mobile_cart_count');

      if (badge) {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      }
    })
    .catch(error => {
      console.log('Cart count error:', error);
    });

});
